import type { ReactElement } from 'react';
import { Link, useLocation } from 'react-router-dom';

function linkClass(active: boolean): string {
  return active ? 'app-main-nav-link app-main-nav-link--active' : 'app-main-nav-link';
}

export function BooksNav(): ReactElement {
  const { pathname } = useLocation();
  return (
    <nav className="app-main-nav" aria-label="Books">
      <Link to="/" className={linkClass(false)}>
        Modules
      </Link>
      <Link to="/contracts" className={linkClass(pathname.startsWith('/contracts'))}>
        Contracts
      </Link>
      <Link to="/commercial" className={linkClass(pathname.startsWith('/commercial'))}>
        Commercial
      </Link>
      <Link to="/accounting" className={linkClass(pathname.startsWith('/accounting'))}>
        Accounting
      </Link>
      <Link to="/master/parties" className={linkClass(pathname.startsWith('/master'))}>
        Master
      </Link>
    </nav>
  );
}
